"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPageTimeFieldProps = exports.withPageDateFieldProps = exports.withChartFieldProps = exports.withImageFieldProps = exports.withFileFieldProps = exports.withPageNumberFieldProps = exports.withPageTextFieldProps = exports.withPageGroupProps = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const getErrorAndWarningProps = ({ errors, warnings, translateFunction, }) => {
    let helperText = '';
    if (errors && errors[0]) {
        helperText = errors[0];
    }
    else if (warnings && warnings[0]) {
        helperText = warnings[0];
    }
    if (translateFunction) {
        helperText = translateFunction(helperText);
    }
    return {
        error: !!(errors && errors[0]),
        warning: warnings && warnings[0] ? true : undefined,
        helperText,
    };
};
const useFilterPageTextFieldProps = (props, type) => {
    const { value, controlDefinition, warnings, readOnly, translateFunction = text => text } = props;
    const { label, placeholder, info, oneLine, truncate } = controlDefinition;
    const filteredProps = Object.assign(Object.assign({ type: type || 'text' }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { value,
        warnings,
        label,
        info, placeholder: placeholder || 'No Placeholder', readOnly,
        oneLine,
        truncate,
        translateFunction });
    return filteredProps;
};
const useGroupProps = (props) => {
    const { controlDefinition, translateFunction = text => text } = props, moreProps = __rest(props, ["controlDefinition", "translateFunction"]);
    const { label } = controlDefinition;
    const filteredProps = Object.assign({ label,
        controlDefinition,
        translateFunction }, moreProps);
    return filteredProps;
};
const withPageGroupProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useGroupProps(Object.assign({ translateFunction }, props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageGroupProps = withPageGroupProps;
const withPageTextFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props));
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageTextFieldProps = withPageTextFieldProps;
const withPageNumberFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'number');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withPageNumberFieldProps = withPageNumberFieldProps;
const withFileFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'file');
        return react_1.default.createElement(Component, Object.assign({}, filteredProps, { translateFunction: translateFunction }));
    };
};
exports.withFileFieldProps = withFileFieldProps;
const withImageFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'image');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { width: props.controlDefinition.width, height: props.controlDefinition.height }))));
    };
};
exports.withImageFieldProps = withImageFieldProps;
const withChartFieldProps = (Component, translateFunction) => {
    return (props) => {
        const filteredProps = useFilterPageTextFieldProps(Object.assign({ translateFunction }, props), 'chart');
        return (react_1.default.createElement(Component, Object.assign({}, Object.assign(Object.assign({}, filteredProps), { chartType: props.controlDefinition.chartType, chartOptions: props.controlDefinition.chartOptions, height: props.controlDefinition.height }))));
    };
};
exports.withChartFieldProps = withChartFieldProps;
const withPageDateFieldProps = (Component, translateFunction) => {
    return (props) => {
        const { value, controlDefinition, warnings, readOnly, defaultDateTimeFormat } = props;
        const valueToUse = value && (typeof value === 'number' || typeof value === 'string') ? new Date(value) : value;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const filteredProps = Object.assign(Object.assign({ label,
            placeholder,
            info, value: valueToUse }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { warnings, onChange: lodash_1.noop, readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat,
            translateFunction });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageDateFieldProps = withPageDateFieldProps;
const withPageTimeFieldProps = (Component, translateFunction) => {
    return (props) => {
        const { value, controlDefinition, readOnly, defaultDateTimeFormat } = props;
        const { label, placeholder, info, oneLine, truncate } = controlDefinition;
        const valueToUse = value && typeof value === 'number' ? new Date(value) : null;
        const filteredProps = Object.assign(Object.assign({ value: valueToUse }, getErrorAndWarningProps(Object.assign({ translateFunction }, props))), { onChange: lodash_1.noop, label,
            placeholder,
            info,
            readOnly,
            oneLine,
            truncate,
            defaultDateTimeFormat,
            translateFunction });
        return react_1.default.createElement(Component, Object.assign({}, filteredProps));
    };
};
exports.withPageTimeFieldProps = withPageTimeFieldProps;
//# sourceMappingURL=PageHelpers.js.map